import { HeaderComponent } from './header.component';
import { UserComponent } from './user/user.component';
import { ReleaseNoteComponent } from './release-note/release-note.component';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatToolbarModule } from '@angular/material/toolbar';

import { A11yModule } from '@angular/cdk/a11y';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderService } from './loader/loader.service';
import { LoaderInterceptor } from './loader/loader.interceptor';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

const loaderProviders = [
  LoaderService,
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LoaderInterceptor,
    multi: true,
  },
];

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatMenuModule,
    MatToolbarModule,
    MatProgressBarModule,
    RouterModule,
    A11yModule,
    OverlayModule,
    NgOptimizedImage,
  ],
  declarations: [HeaderComponent, UserComponent, ReleaseNoteComponent],
  providers: loaderProviders,
  exports: [HeaderComponent],
})
export class HeaderModule {}
